import React from 'react';
import { HiArrowLeft } from 'react-icons/hi';
import { BiChevronRight, BiChevronDown } from 'react-icons/bi';
import { FiCalendar, FiClock, FiSave } from 'react-icons/fi';
import { GiWheat } from 'react-icons/gi';

export default function AllergenHeader() {
  return (
    <header className="w-full bg-white p-6 font-sans select-none">
      {/* Top Navigation Row */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        {/* Breadcrumb */}
        <nav className="flex items-center space-x-1 text-sm font-medium text-blue-600">
          <HiArrowLeft className="w-4 h-4 cursor-pointer text-blue-700" />
          <span className="hover:underline cursor-pointer ml-1">Checks</span>
          <BiChevronRight className="w-5 h-5 text-gray-400" />
          <span className="text-gray-600 font-normal">Allergen Review Check (Monthly)</span>
        </nav>

        {/* Date Selector & View History */}
        <div className="flex items-center space-x-3">
          {/* Date Dropdown */}
          <button className="flex items-center space-x-2 px-3 py-2 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition text-sm font-medium text-gray-800 shadow-sm">
            <FiCalendar className="w-4 h-4 text-gray-500" />
            <span>Today, 28 May 2025</span>
            <BiChevronDown className="w-4 h-4 text-gray-500" />
          </button>

          {/* View History Button */}
          <button className="flex items-center space-x-2 px-4 py-2 border border-gray-200 rounded-lg bg-white hover:bg-gray-50 transition text-sm font-medium text-gray-800 shadow-sm">
            <FiClock className="w-4 h-4 text-gray-500" />
            <span>View history</span>
          </button>
        </div>
      </div>

      {/* Bottom Content Row */}
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        {/* Left Side: Icon, Title, Description, and Tag */}
        <div className="flex items-start space-x-4 max-w-3xl">
          {/* Main Logo Block */}
          <div className="flex-shrink-0 w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-md shadow-blue-100">
            <GiWheat className="w-9 h-9 text-white transform -rotate-12" />
          </div>

          {/* Text Content */}
          <div className="space-y-2">
            <div className="flex flex-wrap items-center gap-3">
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 tracking-tight">
                Allergen Review Check (Monthly)
              </h1>
              {/* Monthly Badge */}
              <span className="inline-flex items-center space-x-1 px-2.5 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-semibold border border-purple-100">
                <FiClock className="w-3 h-3 text-purple-500" />
                <span>Monthly Check</span>
              </span>
            </div>
            <p className="text-gray-500 text-sm md:text-base leading-relaxed">
              Review allergen management systems to ensure accuracy, communication and control measures are up to date.
            </p>
          </div>
        </div>

        {/* Right Side: Action Button */}
        <div className="flex-shrink-0 self-end md:self-start">
          <button className="flex items-center space-x-2 px-5 py-3 bg-blue-600 hover:bg-blue-700 active:bg-blue-800 text-white font-medium rounded-xl shadow-lg shadow-blue-200 transition duration-150 ease-in-out w-full md:w-auto justify-center">
            <FiSave className="w-4 h-4" />
            <span>Save progress</span>
          </button>
        </div>
      </div>
    </header>
  );
}
